import { useEffect } from "react";

import { HASH_REDIRECTS } from "@/lib/hash-redirects";

/** Client-side fallback for old /#section bookmarks after hydration. */
export function HashRedirect() {
  useEffect(() => {
    const apply = () => {
      if (window.location.pathname !== "/") return;
      const hash = window.location.hash.replace(/^#/, "");
      const dest = HASH_REDIRECTS[hash];
      if (!dest) return;
      window.location.replace(dest);
    };

    apply();
    window.addEventListener("hashchange", apply);
    return () => window.removeEventListener("hashchange", apply);
  }, []);

  return null;
}
